import { createSlice } from '@reduxjs/toolkit';

import { getScribeFile, updateFilePermission } from '../../../slices/scribeFileSlice';

const initialState = {
  documents: {},
  loaders: {},
  errors: {}
};

export const documentsSlice = createSlice({
  name: 'documentsSlice',
  initialState,
  reducers: {
    setScribeDocument: (state, action) => {
      const document = action.payload;

      if (document.id in state.documents) {
        return;
      }
      // This is meant to only happen once, when the KnowledgePage is first loaded
      state.documents[document.id] = document;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScribeFile.pending, (state, action) => {
        const documentId = Object(action.meta.arg).id;

        state.loaders[documentId] = true;
      })
      .addCase(getScribeFile.fulfilled, (state, action) => {
        const document = action.payload;

        state.documents[document.id] = document;
        state.loaders[document.id] = false;
      })
      .addCase(getScribeFile.rejected, (state, action) => {
        const documentId = Object(action.meta.arg).id;

        state.loaders[documentId] = false;
        state.errors[documentId] = action.payload;
      })
      .addCase(updateFilePermission.pending, (state, action) => {
        const { documentId } = Object(action.meta.arg);

        state.loaders[documentId] = true;
      })
      .addCase(updateFilePermission.fulfilled, (state, action) => {
        const document = action.payload;

        state.documents[document.id] = document;
        state.loaders[document.id] = false;
      })
      .addCase(updateFilePermission.rejected, (state, action) => {
        const { documentId } = Object(action.meta.arg);

        state.loaders[documentId] = false;
        state.errors[documentId] = action.payload;
      });
  }
});

export const { setScribeDocument } = documentsSlice.actions;
export default documentsSlice.reducer;
